import _classCallCheck from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { __awaiter } from "tslib";
import { optionsFromArguments } from "../../core/util/Defaults";
import { readOnly } from "../../core/util/Interface";
import { Multiply } from "../../signal/Multiply";
import { Source } from "../Source";
import { Oscillator } from "./Oscillator";
import { generateWaveform } from "./OscillatorInterface";
import { PulseOscillator } from "./PulseOscillator";
/**
 * PWMOscillator modulates the width of a Tone.PulseOscillator
 * at the modulationFrequency. This has the effect of continuously
 * changing the timbre of the oscillator by altering the harmonics
 * generated.
 * @example
 * return Tone.Offline(() => {
 * 	const pwm = new Tone.PWMOscillator(60, 0.3).toDestination().start();
 * }, 0.1, 1);
 * @category Source
 */

export var PWMOscillator = /*#__PURE__*/function (_Source) {
  _inherits(PWMOscillator, _Source);

  var _super = _createSuper(PWMOscillator);

  function PWMOscillator() {
    var _this;

    _classCallCheck(this, PWMOscillator);

    _this = _super.call(this, optionsFromArguments(PWMOscillator.getDefaults(), arguments, ["frequency", "modulationFrequency"]));
    _this.name = "PWMOscillator";
    _this.sourceType = "pwm";
    /**
     * Scale the oscillator so it doesn't go silent
     * at the extreme values.
     */

    _this._scale = new Multiply({
      context: _this.context,
      value: 2
    });
    var options = optionsFromArguments(PWMOscillator.getDefaults(), arguments, ["frequency", "modulationFrequency"]);
    _this._pulse = new PulseOscillator({
      context: _this.context,
      frequency: options.modulationFrequency
    }); // change the pulse oscillator type

    _this._pulse.carrierType = "sine";
    _this.modulationFrequency = _this._pulse.frequency;
    _this._modulator = new Oscillator({
      context: _this.context,
      detune: options.detune,
      frequency: options.frequency,
      onstop: function onstop() {
        return _this.onstop(_assertThisInitialized(_this));
      },
      phase: options.phase
    });
    _this.frequency = _this._modulator.frequency;
    _this.detune = _this._modulator.detune; // connections

    _this._modulator.chain(_this._scale, _this._pulse.width);

    _this._pulse.connect(_this.output);

    readOnly(_assertThisInitialized(_this), ["modulationFrequency", "frequency", "detune"]);
    return _this;
  }

  _createClass(PWMOscillator, [{
    key: "_start",
    value:
    /**
     * start the oscillator
     */
    function _start(time) {
      time = this.toSeconds(time);

      this._modulator.start(time);

      this._pulse.start(time);
    }
    /**
     * stop the oscillator
     */

  }, {
    key: "_stop",
    value: function _stop(time) {
      time = this.toSeconds(time);

      this._modulator.stop(time);

      this._pulse.stop(time);
    }
    /**
     * restart the oscillator
     */

  }, {
    key: "_restart",
    value: function _restart(time) {
      this._modulator.restart(time);

      this._pulse.restart(time);
    }
    /**
     * The type of the oscillator. Always returns "pwm".
     */

  }, {
    key: "type",
    get: function get() {
      return "pwm";
    }
    /**
     * The baseType of the oscillator. Always returns "pwm".
     */

  }, {
    key: "baseType",
    get: function get() {
      return "pwm";
    }
    /**
     * The partials of the waveform. Cannot set partials for this waveform type
     */

  }, {
    key: "partials",
    get: function get() {
      return [];
    }
    /**
     * No partials for this waveform type.
     */

  }, {
    key: "partialCount",
    get: function get() {
      return 0;
    }
    /**
     * The phase of the oscillator in degrees.
     */

  }, {
    key: "phase",
    get: function get() {
      return this._modulator.phase;
    },
    set: function set(phase) {
      this._modulator.phase = phase;
    }
  }, {
    key: "asArray",
    value: function asArray() {
      var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1024;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", generateWaveform(this, length));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
    /**
     * Clean up.
     */

  }, {
    key: "dispose",
    value: function dispose() {
      _get(_getPrototypeOf(PWMOscillator.prototype), "dispose", this).call(this);

      this._pulse.dispose();

      this._scale.dispose();

      this._modulator.dispose();

      return this;
    }
  }], [{
    key: "getDefaults",
    value: function getDefaults() {
      return Object.assign(Source.getDefaults(), {
        detune: 0,
        frequency: 440,
        modulationFrequency: 0.4,
        phase: 0,
        type: "pwm"
      });
    }
  }]);

  return PWMOscillator;
}(Source);